"use client";

import React from "react";
import {
  Box,
  Typography,
  TextField,
  Card,
  Grid,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import { CheckCircle } from "@mui/icons-material";
import { ConvertDate } from "../../../Base/helper/baseFunctions";

const ReviewForm = ({ mode = "", setOpenReviewForm, currentStep = 1 }) => {

  const isEmployee = mode === "Employee";
  const isManager = mode === "Manager";
  const isHR = mode === "HR";


  // console.log("isEmployee", isEmployee, "isManager", isManager, "isHR", isHR)

  const steps = ["My Review", "Manager Review", "HR Review", "Completed"];
  const goals = [
    {
      title: "Develop PMS Module",
      category: "API Development",
      description: "Backend APIs completed",
      createdOn: "22-09-2025",
      progress: "90%",
    },
    {
      title: "Improve Frontend UI",
      category: "UI/UX",
      description: "Redesign dashboard and reports",
      createdOn: "10-08-2025",
      progress: "75%",
    },
  ];

  return (
    <Box sx={{ backgroundColor: "#f3edfd", borderRadius: 2, boxShadow: 2, mb: 1 }}>
      {/* Header Navigation */}
      <Box
        display="flex"
        alignItems="center"
        borderBottom="1px solid"
        borderColor="divider"
        pb={2}
        pt={3}
        px={3}
      >
        <Box>
          <ArrowBackButton
            iconSize={18}
            onClick={() => setOpenReviewForm(false)}
          />
        </Box>
        <Box flex={1}>
          <Stepper activeStep={currentStep} alternativeLabel>
            {steps?.map((label, index) => (
              <Step key={label} completed={index < currentStep}>
                <StepLabel StepIconComponent={ColorStepIcon}>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
      </Box>

      {/* Page Content */}
      <Box px={4} py={1}>
        <Box display="flex" flexDirection="column" gap={2} px={3}>
          {/* Employee Information */}
          <Box borderBottom="1px solid" borderColor="divider" py={2}>
            <Typography variant="h6" gutterBottom>
              Employee Information
            </Typography>

            <Grid container rowSpacing={2} columnSpacing={4}>
              <Grid item xs={12} sm={6}>
                <InfoRow label="Employee Name" value={employee?.name} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InfoRow
                  label="Date of Joining"
                  value={employee?.doj ? ConvertDate(employee?.doj) : "-"}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InfoRow label="Designation" value={employee?.designation} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InfoRow label="Email ID" value={employee?.email} />
              </Grid>
            </Grid>
          </Box>

          {/* Goals Section */}
          <Box borderBottom="1px solid" borderColor="divider" pb={2}>
            <Typography variant="h6" gutterBottom>
              Goals
            </Typography>
            <Grid container spacing={2}>
              {goals?.map((goal, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Card sx={{ p: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {goal.title}
                    </Typography>
                    <InfoRow label="Description" value={goal.description} />
                    <InfoRow
                      label="Target Date"
                      value={
                        goal.target_date ? ConvertDate(goal.target_date) : "-"
                      }
                    />
                    <InfoRow label="Status" value={goal.status} />
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Final Review - Skill Maturity and In Year Contribution */}
          <Grid container spacing={2} borderBottom="1px solid" borderColor="divider" pb={2}>
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom>
                Final Review - Skill Maturity
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Employee Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="Employee Comments"
                    disabled= {!isEmployee}
                    sx={{
                      backgroundColor: isEmployee ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Manager Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="Manager Comments"
                    disabled= {!isManager}
                    sx={{
                      backgroundColor: isManager ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    HR Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="HR Comments"
                    disabled= {!isHR}
                    sx={{
                      backgroundColor: isHR ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Final Review - In Year Contribution */}
            <Grid item xs={12} md={6}>
              <Typography variant="h5" gutterBottom>
                Final Review - In Year Contribution
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Employee Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="Employee Comments"
                    disabled={!isEmployee}
                    sx={{
                      backgroundColor: isEmployee ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Manager Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="Manager Comments"
                    disabled= {!isManager}
                    sx={{
                      backgroundColor: isManager ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    HR Comments
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    multiline
                    rows={4}
                    placeholder="HR Comments"
                    disabled={!isHR}
                    sx={{
                      backgroundColor: isHR ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

         {/* Final Ratings */}
          <Grid container spacing={2} borderBottom="1px solid" borderColor="divider" pb={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" gutterBottom>
                Skill Rating
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Manager
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Skill Rating"
                    disabled= {!isManager}
                    sx={{
                      backgroundColor: isManager ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    HR
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Skill Rating"
                    disabled={!isHR}
                    sx={{
                      backgroundColor: isHR ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" gutterBottom>
                Final Year Rating
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Manager
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Final Year Rating"
                    disabled= {!isManager}
                    sx={{
                      backgroundColor: isManager ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Box>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    HR
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Final Year Rating"
                    disabled={!isHR}
                    sx={{
                      backgroundColor: isHR ? "#fff" : "",
                      borderRadius: "10px"
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Final Review Comments */}
          <Box pb={1}>
            <Typography variant="h6" gutterBottom>
              Final Review Comments
            </Typography>
             <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    HR
                  </Typography>
            <TextField
              fullWidth
              size="small"
              multiline
              rows={6}
              placeholder="Final Review Comments"
              disabled={!isHR}
              sx={{
                backgroundColor: isHR ? "#fff" : "",
                borderRadius: "10px"
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
const ColorStepIcon = (props) => {
  const { active, completed, icon } = props;

  return (
    <Box
      sx={{
        width: 22,
        height: 22,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "black",
        fontWeight: "600",
        bgcolor: completed ? "" : active ? "primary.main" : "#ffffff",
      }}
    >
      {completed ? (
        <CheckCircle
          sx={{ width: 22, height: 22 }}
          fontSize="medium"
          color="primary"
        />
      ) : (
        icon
      )}{" "}
    </Box>
  );
};

const InfoRow = ({ label, value }) => {
  return (
    <Grid container spacing={1}>
      <Grid item xs={3.5}>
        <Typography variant="body1" color="textSecondary">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={0.5}>
        <Typography>:</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography fontWeight={500}>{value || "-"}</Typography>
      </Grid>
    </Grid>
  );
};
const employee = {
  name: "Gaurav Raj",
  doj: "2021-07-15",
  designation: "Full Stack Developer",
  email: "gauravraj@example.com",
};

export default ReviewForm;
